import React from "react";
import { Wrapper } from "./style";

const AdminScheduler = () => {
  return <Wrapper>admin-scheduler</Wrapper>;
};

export default AdminScheduler;
